import axios from "axios";
import * as actions from "constants/productConstants";
import {
	dummyImages,
	IImages,
} from "containers/PageAddListing1/PageAddListing7";
import { productUploadInitial } from "store";
import config from "utils/config";
import { AddressType } from "data/types";
import { SingleItem } from "types/interfaces";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { RentripsURL } from "utils/request";

/**
 * Di add listing ini, kita bakal banyak banget ngepost ttg barang yang mau ditambahkan ke listing
 * Kira2 nanti ada 7 page bagi user untuk nambahin produk, dibagi per kategorinya
 */

export const addListingStart = () => async (dispatch: any, getState: any) => {
	const { product } = getState().productUpload;

	const userId = getState().userInfo.userInfo;
	const token = getState().userInfo.userInfo.token || "";

	logging(token, {
		category: "listing",
		action: "add-start",
	});

	eventAnalytic({
		category: "Product",
		action: "upload product start",
		label: `${userId ? userId?.id : "guess"}`,
	});

	dispatch({
		type: actions.PRODUCT_UPDATE_RESET,
		payload: product,
	});
};

// METHOD: POST
// Params: name, category, description
export const addListing1 =
	(name: string, category: string, description: string) =>
	async (dispatch: any, getState: any) => {
		try {
			const { product } = getState().productUpload;
			product.name = name;
			product.category = category;
			product.description = description;

			dispatch({
				type: actions.PRODUCT_ADD_SUCCESS,
				payload: product,
			});
		} catch (error: any) {
			dispatch({ type: actions.PRODUCT_ADD_ERROR });
		}
	};

// METHOD: POST
// Params: name, category, description
export const addListing2 =
	(address: AddressType, locations: { name: string; price: number }[]) =>
	async (dispatch: any, getState: any) => {
		try {
			const { product } = getState().productUpload;
			product.address = address;
			product.locations = locations;

			dispatch({ type: actions.PRODUCT_ADD_SUCCESS, payload: product });
		} catch (error: any) {
			dispatch({ type: actions.PRODUCT_ADD_ERROR });
		}
	};

export const addListing3 =
	(tnc: string) => async (dispatch: any, getState: any) => {
		try {
			const { product } = getState().productUpload;
			product.tnc = tnc;
			dispatch({
				type: actions.PRODUCT_ADD_SUCCESS,
				payload: product,
			});
		} catch (error: any) {
			dispatch({ type: actions.PRODUCT_ADD_ERROR });
		}
	};

export const addListing4 =
	(imagesSent: string[], imagesOrder: IImages[]) =>
	async (dispatch: any, getState: any) => {
		try {
			const { product } = getState().productUpload;
			product.images = imagesOrder;
			product.imagesSent = imagesSent;

			dispatch({
				type: actions.PRODUCT_ADD_SUCCESS,
				payload: product,
			});
		} catch (error: any) {
			dispatch({ type: actions.PRODUCT_ADD_ERROR });
		}
	};

export const addListing5 =
	(edit: boolean, price: number, minimal: number, deposit: number) =>
	async (dispatch: any, getState: any) => {
		try {
			const { product } = getState().productUpload;
			product.price = price;
			product.minRent = minimal;
			product.deposit = deposit;

			dispatch(addListing(edit));

			dispatch({
				type: actions.PRODUCT_ADD_SUCCESS,
				payload: productUploadInitial,
			});
		} catch (error: any) {
			dispatch({ type: actions.PRODUCT_ADD_ERROR });
		}
	};

export const addListing =
	(edit: boolean) => async (dispatch: any, getState: any) => {
		const { token } = getState().userInfo.userInfo;

		try {
			const { product } = getState().productUpload;
			const {
				productId,
				name,
				address,
				locations,
				description,
				category,
				price,
				deposit,
				minRent,
				tnc,
				imagesSent,
			} = product;

			logging(token, {
				category: "listing",
				action: edit ? "update-finish" : "add-finish",
				target: productId,
			});

			if (edit) {
				await axios.patch(
					`${RentripsURL}/api/product/${productId}`,
					{
						name,
						addressId: address._id,
						locations,
						description,
						category,
						price,
						deposit,
						minRent,
						tnc,
						images: imagesSent,
					},
					config(token)
				);
			} else {
				await axios.post(
					RentripsURL + "/api/product",
					{
						name,
						addressId: address._id,
						locations,
						description,
						category,
						price,
						deposit,
						minRent,
						tnc,
						images: imagesSent,
					},
					config(token)
				);
			}

			eventAnalytic({
				category: "Product",
				action: `${edit ? "edit" : "upload"} product`,
				label: `${productId || ""}`,
			});

			dispatch({
				type: actions.PRODUCT_ADD_SUCCESS,
				payload: productUploadInitial,
			});
		} catch (error: any) {
			eventAnalytic({
				category: "Product",
				action: `${edit ? "edit" : "upload"} product failed`,
			});
			dispatch({ type: actions.PRODUCT_ADD_ERROR });
		}
	};

export const updateListing =
	(productId: string) => async (dispatch: any, getState: any) => {
		const { token } = getState().userInfo.userInfo;

		logging(token, {
			category: "listing",
			action: "update-start",
		});

		try {
			eventAnalytic({
				category: "Product",
				action: "update product start",
				label: productId,
			});

			const { product } = getState().productUpload;

			dispatch({ type: actions.PRODUCT_UPDATE_REQUEST, payload: product });

			const { data }: { data: SingleItem } = await axios.get(
				`${RentripsURL}/api/product/${productId}`
			);
			product.name = data.name;
			product.edit = true;
			product.price = data.price;
			product.category = data.category;
			product.description = data.description;
			product.imagesSent = data.images;
			product.tnc = data.tnc;
			product.minRent = data.minRent;
			product.deposit = data.deposit;
			product.address = data.address;
			product.images = dummyImages;
			product.productId = data._id;

			data.images.forEach((image, index) => {
				product.images[index].value = image;
			});

			if (data) {
				setTimeout(() => {
					dispatch({
						type: actions.PRODUCT_UPDATE_REQUEST_SUCCESS,
						payload: product,
					});
				}, 1000);
			}
		} catch (error: any) {
			eventAnalytic({
				category: "Product",
				action: "update product failed",
				label: productId,
			});
			dispatch({ type: actions.PRODUCT_UPDATE_ERROR });
		}
	};
